var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7477 2.25002L20.7523 2.25002L20.774 2.25H20.7783C24.1221 2.26327 29.2746 3.60574 32.2562 8.37632C34.2353 11.5432 34.5678 14.4128 34.2221 16.7739C33.8839 19.0843 32.9023 20.8491 32.3554 21.8312L32.2506 22.0195L20.7499 37.5794L9.2491 22.0195L9.14425 21.831C8.59727 20.8489 7.61582 19.0843 7.27757 16.7739C6.93189 14.4128 7.26436 11.5432 9.24354 8.37633C12.2252 3.6055 17.3781 2.26324 20.7219 2.2501L20.727 2.25009L20.7328 2.25006L20.7477 2.25002ZM30.4746 9.48979C28.0096 5.54568 23.689 4.36318 20.7725 4.35093L20.7469 4.35095L20.7301 4.35101C17.8136 4.36247 13.491 5.54436 11.0251 9.48979C9.31837 12.2208 9.08049 14.5854 9.35634 16.4696C9.63692 18.386 10.4559 19.8682 10.9929 20.8324L11.0194 20.88L20.7499 34.0448L30.4803 20.88L30.5068 20.8325C31.0437 19.8683 31.8628 18.386 32.1434 16.4696C32.4192 14.5854 32.1813 12.2208 30.4746 9.48979ZM19.9677 10.8112C19.9677 10.231 20.4381 9.76069 21.0182 9.76069C24.3635 9.76069 27.0754 12.4726 27.0754 15.8179C27.0754 19.1632 24.3635 21.8751 21.0182 21.8751C17.6729 21.8751 14.961 19.1632 14.961 15.8179C14.961 15.2377 15.4313 14.7674 16.0115 14.7674C16.5916 14.7674 17.0619 15.2377 17.0619 15.8179C17.0619 18.0029 18.8332 19.7742 21.0182 19.7742C23.2032 19.7742 24.9745 18.0029 24.9745 15.8179C24.9745 13.6329 23.2032 11.8616 21.0182 11.8616C20.4381 11.8616 19.9677 11.3913 19.9677 10.8112Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location.70b8e3414fd5cc5e72c6a0f7d2192b4d.svg";